const SvgUserAdd = () => (
	<svg width="1em" height="1em" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx={10.429} cy={6.893} r={5.893} fill="#100D3D" stroke="#100D3D" strokeWidth={2} strokeLinecap="round" />
		<path d="M21.036 9.25v7.072M24.571 12.786H17.5" stroke="#100D3D" strokeWidth={2} strokeLinecap="round" />
		<path
			d="M18.846 21.487c.544-.123.87-.689.63-1.192-.65-1.357-1.72-2.549-3.105-3.447-1.705-1.106-3.793-1.705-5.942-1.705-2.15 0-4.238.6-5.943 1.705-1.385.898-2.454 2.09-3.104 3.447-.241.503.085 1.069.63 1.192a38.112 38.112 0 0 0 16.834 0Z"
			fill="#100D3D"
			stroke="#100D3D"
			strokeWidth={2}
			strokeLinecap="round"
		/>
	</svg>
)

export default SvgUserAdd
